@import 'abstract/variables';
@import 'abstract/colors';

img-slider {
  display: flex;
  margin-right: 15px;

  @include breakpoint(sm) {
    display: block;
    margin-right: 0;
  }

  aside-slider {
    margin-right: 10px;

    @include breakpoint(sm) {
      display: none;
    }
  }

  .main {
    min-width: 300px; /** IE fix for flex with image */
  }

  div[slot="slider-images"] {
    display: none;
  }
}
